import { ICarrierApplicationStates } from 'types/graphqlTypes'
import { TAG_STYLE } from 'transfix-ui'

export enum ERateRank {
  WEIGHTING = 'weighting',
  TOP_TIER = 'top tier',
  GOOD = 'good',
  FAIR = 'fair',
  NEEDS_IMPROVEMENT = 'needs improvement',
  POOR = 'poor',
}

export const RATE_STYLE: Record<ERateRank, string> = {
  [ERateRank.FAIR]: '',
  [ERateRank.WEIGHTING]: '',
  [ERateRank.TOP_TIER]: TAG_STYLE.accentGreen,
  [ERateRank.GOOD]: '',
  [ERateRank.NEEDS_IMPROVEMENT]: TAG_STYLE.warning,
  [ERateRank.POOR]: TAG_STYLE.warning,
}

export const RATE_LABELS: Record<ERateRank, string> = {
  [ERateRank.TOP_TIER]: 'top tier',
  [ERateRank.NEEDS_IMPROVEMENT]: 'needs improvement',
  [ERateRank.POOR]: 'needs improvement',
  [ERateRank.FAIR]: '',
  [ERateRank.WEIGHTING]: '',
  [ERateRank.GOOD]: '',
}

export const CARRIER_STATE_LABELS: Record<ICarrierApplicationStates, string> = {
  [ICarrierApplicationStates.activated]: 'Active',
  [ICarrierApplicationStates.application_submitted]: 'Application submitted',
  [ICarrierApplicationStates.cancelled]: 'Cancelled',
  [ICarrierApplicationStates.conditional]: 'Conditional',
  [ICarrierApplicationStates.do_not_use]: 'Do not use',
  [ICarrierApplicationStates.expired_insurance]: 'Expired insurance',
  [ICarrierApplicationStates.in_review]: 'In review',
  [ICarrierApplicationStates.new]: 'Fresh',
  [ICarrierApplicationStates.other]: 'Other',
  [ICarrierApplicationStates.out_of_service]: 'Out of service',
  [ICarrierApplicationStates.pending]: 'Pending',
  [ICarrierApplicationStates.probation]: 'Probation',
}
